/** 
 * Je potrebne vlozit do HTML
 * <div class="load-products-wrap" products-url="/URL/" products-count="COUNT"></div>
 */

function loadProductsCarousel() {
  var loadProductsNumber = window.innerWidth <= bpMedium ? 2 : 3;

  $(".load-products-wrap[products-url]").each(function () {
    var $this = $(this);

    if ($this.hasClass("products-loading")) return;

    $this.addClass("products-loading");

    var sourceUrl = $this.attr("products-url");
    var productCount = parseInt($this.attr("products-count")) || 3;

    $.get("/cache" + sourceUrl, function (response) {
      var $html = $("<div>").html(response);

      var $products = $html.find(".products.products-block .product").slice(0, productCount);

      if ($products.length === 0) {
        $this.hide();
        return;
      }

      $this.empty().append($products);

      // Cached HTML obsahuje .price-standard v .flags-extra .flag-discount —
      // bez repozície by ostala skrytá, takže ju treba presunúť do .price-final
      // (rovnaká logika ako pre produkty v kategóriách).
      repositionProductElements($products);

      // Lazy-load obrázky
      $products.find("img.swap-image").each(function () {
        var $img = $(this);

        var originalSrc = $img.attr("data-micro-image");
        if (originalSrc) {
          $img.attr("src", originalSrc);

          // preload
          var preloadImg = new Image();
          preloadImg.src = originalSrc;
        }

        // hover
        $img.on("mouseenter", function () {
          var hoverSrc = $img.attr("data-next");
          if (hoverSrc) {
            $img.attr("src", hoverSrc);
          }
        });

        $img.on("mouseleave", function () {
          var original = $img.attr("data-micro-image");
          if (original) {
            $img.attr("src", original);
          }
        });
      });


      // Ak už je carousel, nespúšťame znova
      if ($this.hasClass("carousel-initialized")) return;

      if ($products.length > loadProductsNumber) {
        $this.addClass("products products-block products-related products-additional p-switchable");
        $this.addClass("article_products_wrap carousel__specific_style");
        $products.addClass("carousel__slide");

        $this.find(".carousel_nav, .carousel_dots").remove();

        new Carousel($this[0], {
          Dots: true,
          Navigation: true,
          Autoplay: false,
        });

        addImageBadgeProduct();
        if (window.addBadge5Category === true && typeof window.addBadge5MinPrice !== 'undefined') {
          addBadge5LowPriorityProduct();
        }

        $this.addClass("carousel-initialized");
      }
    });
  });
}
